import {
    defaultSetIsFullScreen,
    FullScreenContext,
} from '@/components/FullScreen/FullScreenContext';
import { env } from '@/utils/env';
import React from 'react';

interface UseFullScreenReturn {
    isSectionFullScreen: boolean;
    isFullScreen: boolean;
    setIsFullScreen: (fullScreen: boolean) => void;
    enabled: boolean;
    portalRef: React.RefObject<HTMLDivElement>;
}

export const useFullScreen = (sectionId: string): UseFullScreenReturn => {
    const {
        fullScreenSectionId,
        isFullScreen,
        setIsFullScreen,
        enabled,
        portalRef,
    } = React.useContext(FullScreenContext);

    // Log out message, when DEV mode and hook is used outside of FullScreenProvider,
    if (env.DEV && setIsFullScreen === defaultSetIsFullScreen) {
        // eslint-disable-next-line no-console
        console.error(
            'useFullScreen can only be used within a FullScreenProvider',
        );
    }

    const setFullScreen = (fullScreen: boolean) => {
        setIsFullScreen(sectionId, fullScreen);
    };

    return {
        portalRef,
        isSectionFullScreen: fullScreenSectionId === sectionId && isFullScreen,
        isFullScreen,
        setIsFullScreen: setFullScreen,
        enabled,
    };
};
